module.exports = __webpack_public_path__ + "img/25.e1f92d21.png";